import {
  Autocomplete,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { isMobile, isTablet, isDesktop } from "react-device-detect";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import Loading from "../../components/loading/loading";
import HeaderPage from "../../components/HeaderPage/Index";
import {
  getData,
  storeData,
  clearData,
  findTitleByEn,
  convertToDate,
} from "../../utils/GlobalHelper";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import thLocale from "date-fns/locale/th";
import enLocale from "date-fns/locale/en-US";
import DesktopDatePickerComponent from "../../components/DesktopDatePickerComponent/DesktopDatePickerComponent";

//Libraries is Deprecated 16 Dec 2023
// import DatePicker from "@mui/lab/DatePicker";
// import LocalizationProvider from "@mui/lab/LocalizationProvider";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import ScrollBarComponentPrefill from "../../components/BoxRightContent/ScrollBarComponentPrefill";
import clsx from "clsx";

import {
  fomatterEN,
  fomatterNumber,
  fomatterTH,
  formatterBackIdCard,
  formatterIdCard,
  mailFormat,
} from "../../utils/formatter";
import GlobalApi from "../../utils/GlobalApi";
import Configs from "../../constants/Configs";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import moment from "moment";
import DatePickerInput from "../../components/DatePickerMoblie/DatePickerInput";
import { isEmpty, values, omit } from "lodash";
import { Box } from "@mui/system";
import EventIcon from "@mui/icons-material/Event";
import qs from "qs";
import DialogWait from "../../components/CustomDialog/DialogWait";
import { sub } from "date-fns";
import {
  CRSBirthAddressKey,
  CRSData,
  CRSEditData,
  CRSRadioChecked,
  IdCardExpireDate,
  Idc,
} from "../../utils/GlobalKey";

const IdcForm = (props) => {
  // 🔧 ตัวแปรพื้นฐาน
  const d = new Date();
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();

  const mb = isMobile ? 16 : 9;

  // ✅ เก็บค่าจาก localStorage ไว้ในตัวแปรก่อน ใช้ซ้ำได้
  const langFromStorage = getData("lang");
  const translations = getData("Translations");
  const checkuserinfo = getData("checkuserinfo") || {};
  const head_token = getData("HeaderManp")?.head_token || "";
  const snapIdCard = getData("uploadImage");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const savedIdc = getData("idc");
  const savedExpire = getData(IdCardExpireDate);
  const url = new URL(window.location.href);
  const refId = url.searchParams.get("refId") || getData("refId") || "";

  // ✅ ค่า default สำหรับข้อมูลบัตรประชาชน
  const defaultInfo = {
    backIdCard: "",
    expireDateCard: null,
    prefixTH: "",
    prefixEN: "",
    otherPrefixTH: "",
    otherPrefixEN: "",
    valuePrefixTH: "",
    valuePrefixEN: "",
    nameTH: "",
    nameEN: "",
    middlenameTH: "",
    middlenameEN: "",
    lastnameTH: "",
    lastnameEN: "",
    nationality: "",
    birthday: null,
  };

  // ✅ locale mapping
  const localeMap = {
    th: thLocale,
    en: enLocale,
  };

  // ✅ useState hooks
  const [isDataPrefixReady, setIsDataPrefixReady] = useState(false);
  const [lang, setLang] = useState(langFromStorage);
  const [isLoading, setIsLoading] = useState(false);
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModelWaitText, setIsModelWaitText] = useState({
    title: "",
    massage: "",
    btn: "",
    errorCode: "",
  });
  const [dataPrefixTH, setDataPrefixTH] = useState([]);
  const [dataPrefixEN, setDataPrefixEN] = useState([]);
  const [dataPrefix, setDataPrefix] = useState([]);
  const [dataCountry, setDataCountry] = useState([]);
  const [jumpPage, setJumpPage] = useState(false);
  const [unExpDate, setUnExpDate] = useState(savedExpire || false);
  const [height, setHeight] = useState(window.innerHeight);

  const [errorText, setErrorText] = useState({
    idCard: "",
    backIdCard: "",
    expireDateCard: "",
    prefixTH: "",
    prefixEN: "",
    nameTH: "",
    lastnameEN: "",
    nameEN: "",
    lastName: "",
    phone: "",
    email: "",
  });

  // ✅ ข้อมูลเริ่มต้นของ information (ดึงจาก localStorage ถ้ามี)
  const [information, setInformation] = useState(
    getData("idc")
      ? getData("idc")
      : {
          idCard: checkuserinfo.cardId ? checkuserinfo.cardId : "",
          backIdCard: "",
          expireDateCard: null,
          prefixTH: "",
          prefixEN: "",
          otherPrefixTH: "",
          otherPrefixEN: "",
          valuePrefixTH: "",
          valuePrefixEN: "",
          nameTH: "",
          nameEN: "",
          middlenameTH: "",
          middlenameEN: "",
          lastnameTH: "",
          lastnameEN: "",
          nationality: "",
          birthday: null,
          phone: checkuserinfo.f0_mobile_phone
            ? checkuserinfo.f0_mobile_phone
            : "",
          email: checkuserinfo.f0_email ? checkuserinfo.f0_email : "",
        },
  );
  useEffect(() => {
    const handleResize = () => {
      const innerHeight = getDynamicHeight(window.innerHeight);
      setHeight(innerHeight);
    };
    window.addEventListener("resize", handleResize);
    // Cleanup event listener เมื่อ component ถูกลบ
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const checkJumpPage = async () => {
    // await getImage();
    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const handleNext = async () => {
    //TODO function nextPage
    let check = 0;
    let errorCheck = { ...errorText };
    //idCard
    if (information?.idCard.length !== 13) {
      errorCheck = {
        ...errorCheck,
        idCard: "กรอกเลขบัตรประชาชนให้ครบ 13 หลัก",
      };
      check++;
    }
    //backCard
    if (information?.backIdCard.length !== 12) {
      errorCheck = {
        ...errorCheck,
        backIdCard: "กรอกเลขหลังบัตรประชาชนให้ครบ 12 หลัก",
      };
      check++;
    }
    //expdate
    console.log(information);

    if (isEmpty(information.expireDateCard)) {
      errorCheck = {
        ...errorCheck,
        expireDateCard: "กรุณาเลือกวันหมดอายุ",
      };
      check++;
    }
    const localeDate = year + "/" + (month + 1) + "/" + day;
    if (
      Number(moment(information.expireDateCard).format("YYYYMMDD")) <=
      Number(moment(localeDate).format("YYYYMMDD"))
    ) {
      errorCheck = {
        ...errorCheck,
        expireDateCard: "กรุณาเลือกวันหมดอายุให้ถูกต้อง",
      };
      check++;
    }

    //prefix
    if (isEmpty(information.prefixTH)) {
      errorCheck = {
        ...errorCheck,
        prefixTH: "กรุณาเลือกคำนำหน้าชื่อ",
      };
      check++;
    }
    if (information.valuePrefixTH === "205") {
      if (isEmpty(information.otherPrefixTH)) {
        errorCheck = {
          ...errorCheck,
          prefixTH: "กรุณาเลือกคำนำหน้าชื่อ อื่นๆ",
        };
        check++;
      }
    }
    //nameth
    if (isEmpty(information.nameTH)) {
      errorCheck = {
        ...errorCheck,
        nameTH: "กรุณากรอกข้อมูล",
      };
      check++;
    }
    //lastNameth
    if (isEmpty(information.lastnameTH)) {
      errorCheck = {
        ...errorCheck,
        lastnameTH: "กรุณากรอกข้อมูล",
      };
      check++;
    }
    //nameen
    if (isEmpty(information.nameEN)) {
      errorCheck = {
        ...errorCheck,
        nameEN: "กรุณากรอกข้อมูล",
      };
      check++;
    }
    //lastNameen
    if (isEmpty(information.lastnameEN)) {
      errorCheck = {
        ...errorCheck,
        lastnameEN: "กรุณากรอกข้อมูล",
      };
      check++;
    }
    //nationality
    if (isEmpty(information.nationality)) {
      errorCheck = {
        ...errorCheck,
        nationality: "กรุณากรอกข้อมูล",
      };
      check++;
    }
    const date100 = year - 120 + "/" + (month + 1) + "/" + day;
    const date20 = year - 20 + "/" + (month + 1) + "/" + day;

    if (
      Number(moment(information.birthday).format("YYYYMMDD")) <
      Number(moment(date100).format("YYYYMMDD"))
    ) {
      errorCheck = {
        ...errorText,
        birthday: "รูปแบบวันเกิดไม่ถูกต้อง วว/ดด/ปปปป",
      };
      check++;
    } else if (
      Number(moment(information.birthday).format("YYYYMMDD")) >
      Number(moment(date20).format("YYYYMMDD"))
    ) {
      errorCheck = {
        ...errorCheck,
        birthday: "วันเดือนปีเกิดต่ำกว่า 20 ปี",
      };
      check++;
    } else if (isEmpty(information.birthday)) {
      errorCheck = {
        ...errorCheck,
        birthday: "กรุณากรอกข้อมูลวันเดือนปีเกิด",
      };
      check++;
    }

    //phone
    if (information.phone.length !== 10) {
      errorCheck = {
        ...errorCheck,
        phone: "กรุณากรอกข้อมูลให้ครบ 10 หลัก",
      };
      check++;
    }
    //email
    if (!mailFormat(information.email)) {
      errorCheck = {
        ...errorCheck,
        email: "กรุณากรอกอีเมลให้ถูกต้อง",
      };
      check++;
    }
    if (check === 0) {
      let birthday = new Date(
        moment(information.birthday).format("YYYY/MM/DD"),
      );
      birthday =
        birthday.getFullYear() +
        543 +
        "" +
        (birthday.getMonth() < 9
          ? "0" + (birthday.getMonth() + 1)
          : birthday.getMonth() + 1) +
        "" +
        (birthday.getDate() < 10
          ? "0" + birthday.getDate()
          : birthday.getDate());
      let verifyData = {
        card_id: information.idCard,
        firstname_th: information.nameTH,
        lastname_th: information.lastnameTH,
        birthday: birthday,
        lazer_card: information.backIdCard,
      };
      checkDopa(verifyData);
    } else {
      setErrorText({ ...errorCheck });
    }
  };

  const checkDopa = async (data) => {
    setIsLoading(true);
    const isDev = process.env.REACT_APP_ENVIRONMENT === "development";
    try {
      GlobalApi.post(
        `${Configs.baseAPIURL03}${
          isDev ? "/form/dopa/manp" : "/form/header/verify"
        }`,
        isDev
          ? {
              card_id: data.card_id,
              first_name: data.firstname_th.toUpperCase(),
              last_name: data.lastname_th.toUpperCase(),
              birthday: moment(information.birthday).format("YYYY-MM-DD"),
              verify_date: moment().format("YYYY-MM-DD HH:mm:ss"),
            }
          : qs.stringify(data),
      )
        .then(async (res) => {
          setIsLoading(false);
          const isSuccess = isDev
            ? res.data.Data[0].IsSuccess
            : res.data.Data[0][0].IsSuccess;
          if (isSuccess === 0) {
            setIsModelWaitText({
              title: res.data.Data[0][0].MsgDescTitle,
              massage: res.data.Data[0][0].MsgDesc,
              errorCode: res.data.Data[0][0].ErrorCode,
              btn: "กลับ",
            });
          } else {
            //เก็บข้อมูลหน้านี้
            await clearData("first_otp");
            storeData(Idc, information);
            storeData(IdCardExpireDate, unExpDate);

            //ไปยังหน้า CRS
            await clearData(CRSBirthAddressKey);
            await clearData(CRSData);
            await clearData(CRSEditData);
            await clearData(CRSRadioChecked);

            if (information?.expireDateCard === "99991231") {
              storeData("unExpDate", true);
              props.history.push("/house_registration");
            } else {
              props.history.push("/birth_address");
            }
            //
            // await clearData("first_otp");
            // storeData("idc", information);
            // props.history.push("/otp");
          }
        })
        .catch((error) => {
          setIsLoading(false);
          let mss = "";
          let title_mss = "";
          if (!!error.isAxiosError && !error.response) {
            title_mss = "เกิดข้อผิดพลาด";
            mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
          } else {
            title_mss =
              error?.response?.data?.Data !== undefined &&
              error?.response?.data?.Data[0][0].MsgDescTitle !== ""
                ? error?.response?.data?.Data[0][0].MsgDescTitle
                : "เกิดข้อผิดพลาด";
            mss =
              error.response?.data?.Data !== undefined &&
              error.response?.data?.Data[0][0].MsgDesc !== ""
                ? error.response?.data?.Data[0][0].MsgDesc
                : "ขออภัยข้อมูลของท่านไม่ถูกต้อง กรุณาตรวจสอบข้อมูลในหน้าตรวจสอบตัวตนอีกครั้ง";
          }
          setIsModelWaitText({
            title: title_mss,
            massage: mss,
            btn: "กลับ",
          });
        });
    } catch (err) {
      setIsLoading(false);
      setIsModelWaitText({
        title: "เกิดข้อผิดพลาด",
        massage: err,
        btn: "กลับ",
      });
    }
  };
  const changeExpireDate = (e) => {
    setErrorText({
      ...errorText,
      expireDateCard: "",
    });
    setInformation({
      ...information,
      expireDateCard: e ? moment(e).format("YYYYMMDD") : "",
    });
  };
  const changeIdCard = (e) => {
    if (e.target.value.length === 13) {
      setErrorText({
        ...errorText,
        idCard: "",
      });
    }
    setInformation({
      ...information,
      idCard: fomatterNumber(e.target.value),
    });
  };
  const changebackIdCard = (e) => {
    if (e.target.value.length === 12) {
      setErrorText({
        ...errorText,
        backIdCard: "",
      });
    }
    let text = e.target.value
      .replace(/[^a-zA-Z0-9]/g, "")
      .split("")
      .slice(0, 12);
    let backId = "";
    text.forEach((t, i) => {
      if (i < 2) {
        backId += fomatterEN(t);
      } else {
        backId += fomatterNumber(t);
      }
    });
    setInformation({
      ...information,
      backIdCard: backId.toUpperCase(),
    });
  };
  const changeCheckExp = (e) => {
    if (!isEmpty(e.target.value)) {
      setErrorText({
        ...errorText,
        expireDateCard: null,
      });
    }
    if (e.target.checked) {
      setInformation({
        ...information,
        expireDateCard: "99991231",
      });
    } else {
      setInformation({
        ...information,
        expireDateCard: null,
      });
    }
    setUnExpDate(e.target.checked);
  };
  const changeNameTH = (e) => {
    if (!isEmpty(e.target.value)) {
      setErrorText({
        ...errorText,
        nameTH: "",
      });
    }
    setInformation({
      ...information,
      nameTH: fomatterTH(e.target.value),
    });
  };
  const changeMiddleNameTH = (e) => {
    setInformation({
      ...information,
      middlenameTH: fomatterTH(e.target.value).replaceAll(/\s/g, ""),
    });
  };
  const changeLastNameTH = (e) => {
    if (!isEmpty(e.target.value)) {
      setErrorText({
        ...errorText,
        lastnameTH: "",
      });
    }
    setInformation({
      ...information,
      lastnameTH: fomatterTH(e.target.value),
    });
  };
  const changeNameEN = (e) => {
    if (!isEmpty(e.target.value)) {
      setErrorText({
        ...errorText,
        nameEN: "",
      });
    }
    setInformation({
      ...information,
      nameEN: fomatterEN(e.target.value),
    });
  };
  const changeMiddleNameEN = (e) => {
    setInformation({
      ...information,
      middlenameEN: fomatterEN(e.target.value).replaceAll(/\s/g, ""),
    });
  };
  const changeLastNameEN = (e) => {
    if (!isEmpty(e.target.value)) {
      setErrorText({
        ...errorText,
        lastnameEN: "",
      });
    }
    setInformation({
      ...information,
      lastnameEN: fomatterEN(e.target.value),
    });
  };
  const changePhoneNumber = (e) => {
    if (e.target.value.length === 10) {
      setErrorText({
        ...errorText,
        phone: "",
      });
    }
    setInformation({
      ...information,
      phone: fomatterNumber(e.target.value),
    });
  };
  const changeEmail = (e) => {
    if (mailFormat(e.target.value)) {
      setErrorText({
        ...errorText,
        email: "",
      });
    }
    setInformation({
      ...information,
      email: e.target.value,
    });
  };
  const changeNationality = (value) => {
    setErrorText({
      ...errorText,
      nationality: "",
    });
    setInformation({ ...information, nationality: value });
  };
  const changeBirthday = (e) => {
    setErrorText({
      ...errorText,
      birthday: "",
    });
    setInformation({
      ...information,
      birthday: e
        ? moment(e).format("YYYYMMDD")
        : moment(year + "/" + month + "/" + day).format("YYYYMMDD"),
    });
  };
  const changeOtherPrefixTH = (e) => {
    setErrorText({
      ...errorText,
      prefixTH: "",
    });
    console.log(e);

    setInformation({
      ...information,
      otherPrefixTH: fomatterTH(e.target.value),
    });
  };
  const changeOtherPrefixEN = (e) => {
    setErrorText({
      ...errorText,
      prefixEN: "",
    });
    setInformation({
      ...information,
      otherPrefixEN: fomatterEN(e.target.value),
    });
  };
  const callPrefix = async () => {
    setIsLoading(true);
    try {
      const res = await GlobalApi.get(`${Configs.baseAPIURL03}/constant/title`);
      if (res.status === API_CODE_SUCCESS) {
        if (res.data) {
          const data = res.data.Data;
          let changeDataTH = [];
          let changeDataEN = [];
          data.forEach((row) => {
            changeDataTH.push({
              prefixEN: row.NameEN,
              label: row.NameTH,
              value: row.Id,
            });
            changeDataEN.push({
              prefixTH: row.NameTH,
              label: row.NameEN,
              value: row.Id,
            });
          });
          setDataPrefixTH([...changeDataTH]);
          setDataPrefixEN([...changeDataEN]);
          setDataPrefix([...data]);
          return data; // ✅ return ค่าที่ init() ต้องใช้ต่อ
        }
      }
      return []; // ✅ กรณี status ไม่ success หรือไม่มี res.data
    } catch (error) {
      setIsLoading(false);
      setIsModelWaitText({
        title: "เกิดข้อผิดพลาด",
        massage: error,
        btn: "กลับ",
      });
      return []; // ✅ กรณี error ก็ return array ว่าง ป้องกัน undefined
    }
  };
  const callCountry = async () => {
    try {
      GlobalApi.get(`${Configs.baseAPIURL03}/constant/country`)
        .then((res) => {
          if (res.status === API_CODE_SUCCESS) {
            if (res.data) {
              const data = res.data.Data;
              let changeData = [];
              data.forEach((row) => {
                if (row.ThName === "ไทย") {
                  setInformation({
                    ...information,
                    nationality: {
                      label: row.ThName,
                      value: row.Id,
                    },
                  });
                }
                changeData.push({
                  label: row.ThName,
                  value: row.Id,
                });
              });
              setDataCountry([...changeData]);
            }
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setIsModelWaitText({
            title: "เกิดข้อผิดพลาด",
            massage: err,
            btn: "กลับ",
          });
        });
    } catch (error) {
      setIsLoading(false);
      setIsModelWaitText({
        title: "เกิดข้อผิดพลาด",
        massage: error,
        btn: "กลับ",
      });
    }
  };
  const getBaseInfo = () => ({
    idCard: checkuserinfo?.cardId || "",
    phone: checkuserinfo?.f0_mobile_phone || "",
    email: checkuserinfo?.f0_email || "",
    backIdCard: getData("idc")?.backIdCard || "",
  });

  // 🔰 ตั้งค่า default เมื่อตอน mount

  // useEffect(() => {
  //   setInformation({ ...defaultInfo, ...getBaseInfo() });
  // }, []);
  // ✅ ฟังก์ชัน OCR
  const ocrFrontIdInfo = async (ref, prefixData) => {
    setIsLoading(true);
    const baseInfo = getBaseInfo();
    console.log("OCR refId:", ref, "baseInfo:", baseInfo);
    let isSuccess = false;
    try {
      // --- Save reference ID for tracking ---
      storeData("refId", ref);

      // --- Build request body ---
      const body = {
        verification_id: ref,
        verification_type: "OCR",
        card_id: baseInfo.idCard,
        channel: "OA",
        token: "",
        head_token: "",
      };

      // --- Call API ---
      const res = await GlobalApi.post(
        `${Configs.baseAPIURL01}/ocr/verify-info`,
        body,
        { headers: { "Content-Type": "application/json" } },
      );

      const info = res?.data?.data;
      if (info?.ocrStatus === "SUCCESS") {
        const newInfo = mapOcrInfoToApp(info, baseInfo, prefixData);
        storeData("ocrUpload", true);
        storeData("idc", newInfo);
        setInformation(newInfo);
        console.log("OCR info mapped to app:", newInfo);
        isSuccess = true;
      } else {
        storeData("ocrUpload", false);
        applyFallbackInfo();
      }
    } catch (error) {
      handleError(error);
    } finally {
      if (!isSuccess) applyFallbackInfo();
      storeData("stepFailed", null);
      setIsLoading(false);
    }
  };

  // --- Helpers ---
  const applyFallbackInfo = () => {
    const baseInfo = getBaseInfo();
    const fallbackInfo = savedIdc
      ? { ...savedIdc, ...baseInfo }
      : { ...defaultInfo, ...baseInfo };
    setInformation(fallbackInfo);
  };

  const handleError = (error) => {
    console.error("Upload failed:", error);
    setInformation({ ...defaultInfo, ...getBaseInfo() });
    setIsModelWaitText({
      title: "เกิดข้อผิดพลาด",
      massage:
        error?.response?.data?.message ||
        error?.message ||
        "ไม่สามารถอัปโหลดได้",
      btn: translations?.[lang]?.snapidcard?.alert_upload?.btn,
    });
  };

  const mapOcrInfoToApp = (info, baseInfo, prefixData) => {
    const title = findTitleByEn(info.title_en, prefixData) || {};
    const valuePrefix = title?.Id || "205";

    // ล้างค่าเก่าก่อนเสมอ ป้องกันค้างจาก scan ครั้งก่อน
    localStorage.removeItem("unExpDate");
    setUnExpDate(null);

    // if (info?.date_of_expiry_en === "LIFELONG") {
    //   setUnExpDate(true);
    //   storeData("unExpDate", true);
    // }

    return {
      ...baseInfo,
      prefixTH: !title?.Id && info?.title_th ? "อื่นๆ" : title?.NameTH || "",
      prefixEN: title?.NameEN || info?.title_en || "",
      valuePrefixTH: valuePrefix,
      valuePrefixEN: valuePrefix,
      expireDateCard: convertToDate(info?.date_of_expiry_en), // null เมื่อ LIFELONG
      nameTH: info?.first_name_th || "",
      nameEN: info?.first_name_en || "",
      middlenameTH: info?.middle_name_th || "",
      middlenameEN: info?.middle_name_en || "",
      lastnameTH: info?.last_name_th || "",
      lastnameEN: info?.last_name_en || "",
      birthday: convertToDate(info?.date_of_birth_en),
      otherPrefixTH: !title?.Id ? info?.title_th || "" : "",
      otherPrefixEN: !title?.Id ? info?.title_en || "" : "",
      nationality: { label: "ไทย", value: "212" },
    };
  };

  useEffect(() => {
    if (!isEmpty(isModelWaitText.title)) setIsModelWait(true);
  }, [isModelWaitText]);
  useEffect(() => {
    if (dataPrefix.length > 0) {
      setIsDataPrefixReady(true);
    }
  }, [dataPrefix]);
  useEffect(() => {
    const init = async () => {
      try {
        const prefixResult = await callPrefix();
        await callCountry();
        clearData("back_from_idc");
        console.log("refId:", refId, "prefixResult:", prefixResult);
        setIsDataPrefixReady(prefixResult?.length > 0);

        if (refId && prefixResult?.length > 0) {
          storeData("refId", refId);
          await ocrFrontIdInfo(refId, prefixResult);
        }
      } catch (error) {
        setIsModelWaitText({
          title: "เกิดข้อผิดพลาด",
          massage: error,
          btn: "กลับ",
        });
      } finally {
        setIsLoading(false); // ✅ รันเสมอ ไม่ว่าจะสำเร็จหรือ error
      }
    };
    init();
  }, []);

  const clickBack = async () => {
    const back_form_otp = getData("back_form_otp");
    const goToAddress = getData("goToAddress") ? getData("goToAddress") : "";
    if (!back_form_otp) {
      if (goToAddress) {
        // todo
      } else {
        clearData("back_form_otp");
        clearData(Idc);
        clearData(IdCardExpireDate);
      }
    }
    await storeData("back_from_idc", true);
    await props.history.push("/snapidcard");
  };
  const getDynamicHeight = (height) => {
    console.log("getDynamicHeight called with height:", height);
    if (isMobile) {
      return `${height > 800 ? height - 350 : height - 300}px`;
    } else if (isTablet) {
      return `${height > 900 ? height - 370 : height - 320}px`;
    } else if (isDesktop) {
      return `${height > 820 ? height - 400 : height - 320}px`;
    } else {
      return "80vh"; // fallback
    }
  };

  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.home?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? clickBack() : "")}
          />
          <Loading status={isLoading} />
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={isModelWaitText.title}
            massage={isModelWaitText.massage}
            errorCode={isModelWaitText?.errorCode}
            btn={isModelWaitText.btn}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.idc}
                        clickBack={(e) => clickBack()}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={mb}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: isMobile ? "100%" : "100%",
                          }}
                        >
                          <HeaderRight
                            title={translations?.[lang]?.idc?.title}
                          />
                          <ScrollBarComponentPrefill
                            // style={{ height: isMobile ? "85vh" : `${height}px` }}
                            content={
                              <Grid>
                                <Typography className="font-20 text-primary">
                                  ข้อมูลบัตรประจำตัวประชาชน
                                </Typography>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <TextField
                                      className="font-20 input-disabled"
                                      id="idCard"
                                      label="หมายเลขบัตรประจำตัวประชาชน"
                                      variant="standard"
                                      onChange={changeIdCard}
                                      value={
                                        formatterIdCard(information?.idCard) ||
                                        ""
                                      }
                                      inputProps={{
                                        maxLength: 13,
                                      }}
                                      disabled
                                      required
                                    />
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.idCard}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <TextField
                                      className="font-20"
                                      id="lazerId"
                                      label="หมายเลขเลเซอร์หลังบัตรประจำตัวประชาชน"
                                      variant="standard"
                                      onChange={changebackIdCard}
                                      value={formatterBackIdCard(
                                        information?.backIdCard ?? "",
                                      )}
                                      required
                                    />
                                    <Box
                                      component="div"
                                      sx={{ display: "inline" }}
                                      className="text-primary font-20 font-DBHeavent"
                                    >
                                      ตัวอย่าง JT1234567890
                                    </Box>
                                    <Box
                                      component="div"
                                      sx={{ display: "inline" }}
                                    >
                                      <FormHelperText className="text-error text-right">
                                        {errorText?.backIdCard}
                                      </FormHelperText>
                                    </Box>
                                  </FormControl>
                                </Grid>
                                <Grid
                                  className={clsx(
                                    "input-form",
                                    unExpDate ? "hide" : "",
                                  )}
                                >
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    {!isMobile ? (
                                      <>
                                        <DesktopDatePickerComponent
                                          id="expDate"
                                          label="วันหมดอายุ (ค.ศ.)"
                                          value={
                                            information?.expireDateCard !==
                                              "99991231" &&
                                            information?.expireDateCard
                                              ? moment(
                                                  information?.expireDateCard,
                                                  "YYYYMMDD",
                                                ).toDate()
                                              : null
                                          }
                                          minDate={new Date(year, month, day)}
                                          maxDate={new Date(year + 100, 12, 31)}
                                          onChange={(value) =>
                                            changeExpireDate(value)
                                          }
                                          required={true}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <Grid>
                                          <Typography className="text-primary font-16 font-normal">
                                            วันหมดอายุ (ค.ศ.)*
                                          </Typography>
                                          <Grid className="date-idc-mb">
                                            <DatePickerInput
                                              value={
                                                information?.expireDateCard ||
                                                null
                                              }
                                              minDate={
                                                new Date(year, month, day)
                                              }
                                              onSelected={changeExpireDate}
                                            />
                                            <EventIcon className="icon-date" />
                                          </Grid>
                                        </Grid>
                                      </>
                                    )}
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.expireDateCard}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                    sx={{ marginLeft: "-5px" }}
                                  >
                                    <FormControlLabel
                                      classes={{
                                        label: clsx("text-primary", "font-20"),
                                      }}
                                      value={unExpDate || ""}
                                      onChange={changeCheckExp}
                                      control={<Checkbox checked={unExpDate} />}
                                      label={"บัตรประจำตัวประชาชนประเภทตลอดชีพ"}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <Autocomplete
                                      options={dataPrefixTH}
                                      value={
                                        information?.prefixTH
                                          ? {
                                              label: information?.prefixTH,
                                              value: information?.valuePrefixTH,
                                            }
                                          : null
                                      }
                                      getOptionLabel={(option) =>
                                        option.label ? option.label : ""
                                      }
                                      isOptionEqualToValue={(option, value) =>
                                        option.label === value.label
                                      }
                                      onChange={(e, value) => {
                                        setErrorText({
                                          ...errorText,
                                          prefixTH: "",
                                        });
                                        console.log(value);

                                        setInformation({
                                          ...information,
                                          prefixTH: value?.label,
                                          valuePrefixTH: value?.value,
                                          prefixEN: value?.prefixEN,
                                          valuePrefixEN: value?.value,
                                          otherPrefixTH:
                                            value?.value === "205"
                                              ? information?.otherPrefixTH
                                              : "",
                                        });
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          id="prefixTH"
                                          variant="standard"
                                          label="คำนำหน้าชื่อ (ภาษาไทย)"
                                          required
                                        />
                                      )}
                                    />
                                    {information?.valuePrefixTH === "205" && (
                                      <Grid className="input-form pt-4">
                                        <TextField
                                          className="font-20"
                                          id="standard-basic"
                                          label="คำนำหน้าชื่อ"
                                          value={
                                            information?.otherPrefixTH || ""
                                          }
                                          onChange={changeOtherPrefixTH}
                                          variant="standard"
                                          fullWidth
                                          required
                                        />
                                      </Grid>
                                    )}
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.prefixTH}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <TextField
                                      className="font-20"
                                      id="nameTH"
                                      label="ชื่อ (ภาษาไทย)"
                                      variant="standard"
                                      onChange={changeNameTH}
                                      value={information?.nameTH || ""}
                                      required
                                    />
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.nameTH}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl variant="standard" fullWidth>
                                    <TextField
                                      className="font-20"
                                      id="middleNameTH"
                                      label="ชื่อกลาง (ภาษาไทย) (ถ้ามี)"
                                      variant="standard"
                                      onChange={changeMiddleNameTH}
                                      value={information?.middlenameTH || ""}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <TextField
                                      className="font-20"
                                      id="lastNameTH"
                                      label="นามสกุล (ภาษาไทย)"
                                      variant="standard"
                                      onChange={changeLastNameTH}
                                      onBlur={(e) =>
                                        setInformation({
                                          ...information,
                                          lastnameTH: fomatterTH(
                                            e.target.value,
                                          ).trim(),
                                        })
                                      }
                                      value={information?.lastnameTH || ""}
                                      required
                                    />
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.lastnameTH}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <Autocomplete
                                      options={dataPrefixEN}
                                      value={
                                        information?.prefixTH
                                          ? {
                                              label: information?.prefixEN,
                                              value: information?.valuePrefixEN,
                                            }
                                          : null
                                      }
                                      getOptionLabel={(option) =>
                                        option.label ? option.label : ""
                                      }
                                      isOptionEqualToValue={(option, value) =>
                                        option.label === value.label
                                      }
                                      onChange={(e, value) => {
                                        setErrorText({
                                          ...errorText,
                                          prefixEN: "",
                                        });
                                        setInformation({
                                          ...information,
                                          prefixTH: value?.prefixTH,
                                          valuePrefixTH: value?.value,
                                          prefixEN: value?.label,
                                          valuePrefixEN: value?.value,
                                          otherPrefixEN:
                                            value?.value === "205"
                                              ? information?.otherPrefixEN
                                              : "",
                                        });
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          InputProps={{
                                            readOnly: true,
                                          }}
                                          id="prefixEN"
                                          variant="standard"
                                          label="คำนำหน้าชื่อ (ภาษาอังกฤษ) "
                                          required
                                        />
                                      )}
                                    />
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.prefixEN}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <TextField
                                      className="font-20"
                                      id="nameEN"
                                      label="ชื่อ (ภาษาอังกฤษ)"
                                      variant="standard"
                                      onChange={changeNameEN}
                                      value={information?.nameEN || ""}
                                      required
                                    />
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.nameEN}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl variant="standard" fullWidth>
                                    <TextField
                                      className="font-20"
                                      id="middleNameEN"
                                      label="ชื่อกลาง (ภาษาอังกฤษ) (ถ้ามี)"
                                      variant="standard"
                                      onChange={changeMiddleNameEN}
                                      value={information?.middlenameEN || ""}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <TextField
                                      className="font-20"
                                      id="lastNameEN"
                                      label="นามสกุล (ภาษาอังกฤษ)"
                                      variant="standard"
                                      onChange={changeLastNameEN}
                                      onBlur={(e) =>
                                        setInformation({
                                          ...information,
                                          lastnameEN: fomatterEN(
                                            e.target.value,
                                          ).trim(),
                                        })
                                      }
                                      value={information?.lastnameEN || ""}
                                      required
                                    />
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.lastnameEN}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <Autocomplete
                                      options={dataCountry}
                                      value={information?.nationality || null}
                                      getOptionLabel={(option) =>
                                        option.label ? option.label : ""
                                      }
                                      defaultValue={dataCountry.find(
                                        (v) => v.label[0],
                                      )}
                                      isOptionEqualToValue={(option, value) =>
                                        option.label === value.label
                                      }
                                      onChange={(e, value) =>
                                        changeNationality(value)
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          id="lang"
                                          variant="standard"
                                          label="ประเทศเจ้าของสัญชาติ"
                                          required
                                        />
                                      )}
                                    />
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.nationality}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    {!isMobile ? (
                                      <DesktopDatePickerComponent
                                        id="birthday"
                                        label="วันเดือนปี (ค.ศ.) เกิด"
                                        value={
                                          information?.birthday
                                            ? moment(
                                                information?.birthday,
                                                "YYYYMMDD",
                                              ).toDate()
                                            : null
                                        }
                                        minDate={
                                          new Date(year - 120, month, day)
                                        }
                                        maxDate={
                                          new Date(year - 20, month, day)
                                        }
                                        openTo="year"
                                        views={["year", "month", "day"]}
                                        onChange={(value) => {
                                          if (
                                            value &&
                                            !isNaN(new Date(value).getTime())
                                          ) {
                                            changeBirthday(
                                              new Date(value).toISOString(),
                                            );
                                          }
                                        }}
                                        required={true}
                                      />
                                    ) : (
                                      <>
                                        <Grid>
                                          <Typography className="text-primary font-16 font-normal">
                                            วันเดือนปี (ค.ศ.) เกิด *
                                          </Typography>
                                          <Grid className="date-idc-mb">
                                            <DatePickerInput
                                              value={
                                                information?.birthday || null
                                              }
                                              minDate={sub(new Date(), {
                                                years: 120,
                                              })}
                                              maxDate={sub(new Date(), {
                                                years: 20,
                                              })}
                                              onSelected={changeBirthday}
                                            />
                                            <EventIcon className="icon-date" />
                                          </Grid>
                                        </Grid>
                                      </>
                                    )}
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.birthday}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <TextField
                                      className="font-20"
                                      id="phone"
                                      label="เบอร์โทรศัพท์มือถือ"
                                      variant="standard"
                                      onChange={changePhoneNumber}
                                      value={information?.phone || ""}
                                      inputProps={{
                                        maxLength: 10,
                                      }}
                                      disabled
                                      required
                                    />
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.phone}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                  >
                                    <TextField
                                      className="font-20"
                                      label="อีเมล"
                                      id="email"
                                      variant="standard"
                                      onChange={changeEmail}
                                      value={information?.email || ""}
                                      disabled
                                      required
                                    />
                                    <FormHelperText className="text-error text-right">
                                      {errorText?.email}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            }
                          />
                          <Grid
                            className="font-DBHeavent font-16 font-weight-bold"
                            style={{
                              color: "red",
                              marginBottom: "0px",
                              marginTop: "10px",
                            }}
                          >
                            * ข้อมูลที่ระบบกรอกให้ (Prefill)
                            เป็นเพียงการอ่านจากรูปบัตรประชาชน
                            กรุณาตรวจสอบข้อมูลก่อนทำรายการต่อ
                          </Grid>
                          <ButtonRight
                            text={translations?.[lang]?.idc?.next}
                            onNextPage={handleNext}
                            btnStyle={{
                              transform: "unset",
                              top: "0",
                              height: "47px !important",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(IdcForm);
